export const INTEGRATE_GOOGLE_ADS =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ADS/INTEGRATE'
export const INTEGRATE_GOOGLE_ADS_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ADS/INTEGRATE_SUCCESS'
export const INTEGRATE_GOOGLE_ADS_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ADS/INTEGRATE_ERROR'
